import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-berechtigungen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerBerechtigungenAdminEffects {

    BenutzerBerechtigungenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_BERECHTIGUNGEN_ADMIN),
        mergeMap((x: ac.GetBenutzerBerechtigungenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerBerechtigungenAdmin(x.benutzerId).pipe(
                map((result: any) => {
                    return new ac.GetBenutzerBerechtigungenAdminErfolgreichAction(result, x.benutzerId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerBerechtigungenAdminFehlerAction(error, x.benutzerId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminQueryService);
        }
        return this.service;
    }
}
